module.exports = __webpack_public_path__ + "static/img/product_images_20_h5_zh.c2b7f5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_20_h5_zh.png
// module id = B4kJ
// module chunks = 34